var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowPatientPhoneWarning)?_c('div',{staticClass:"patient-warning__container flex--center--center"},[_c('div',{staticClass:"patient-warning"},[_vm._v(" "+_vm._s(_vm.patientPhoneWarningMessage)+" ")])]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }